import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useAbbottCgmEnabled = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.ABBOTT_CGM_ENABLED);
